module.exports = __webpack_public_path__ + "static/img/1003_big.4476e56.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1003_big.png
// module id = RQOv
// module chunks = 1